import registerNep from '~/tenants/nep/register';
import registerMpx from '~/tenants/mpx/register';
import registerBre from '~/tenants/bre/register';
import registerDemo from '~/tenants/demo/register';
import registerTwt from '~/tenants/twt/register';
import registerTwt2 from '~/tenants/twt2/register';
import registerMpi from '~/tenants/mpi/register';
import registerPic from '~/tenants/pic/register';
import registerMcm from '~/tenants/mcm/register';
import registerMlm from '~/tenants/mlm/register';
import registerBmd from '~/tenants/bmd/register';

export function registerTenants() {
  registerBre();
  registerMcm();
  registerNep();
  registerMpx();
  registerDemo();
  registerTwt();
  registerTwt2();
  registerMpi();
  registerPic();
  registerMlm();
  registerBmd();
}
